import {
  backgroundImageLinearGradient,
  mq,
  propToBottom,
} from '@sleepstation/style-api-helpers'
import { reversedAltTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { css, ThemeProvider, withTheme } from 'styled-components'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const toBackgroundImage = (size) => (props) => {
  const image = props.images[size]
  return css`
    background-image: url(${image.url});
    background-position: ${image.position};
  `
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: relative;
  overflow: hidden;
  margin-bottom: 0 !important;
  ${backgroundImageLinearGradient()}
`

const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  ${propToBottom(`imageOffsetBottom`)}
  background-repeat: no-repeat;

  ${mq(`xSmallOnly`)} {
    ${toBackgroundImage(`xSmall`)}
  }

  ${mq(`smallOnly`)} {
    ${toBackgroundImage(`small`)}
  }

  ${mq(`mediumUp`)} {
    ${toBackgroundImage(`medium`)}
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HeroBreakoutModule = ({ children, images, imageOffsetBottom }) => (
  <ThemeProvider theme={reversedAltTheme}>
    <Layout className="Breakout">
      <Image images={images} imageOffsetBottom={imageOffsetBottom} />
      {children}
    </Layout>
  </ThemeProvider>
)

HeroBreakoutModule.propTypes = {
  children: PropTypes.node.isRequired,
  images: PropTypes.object.isRequired,
  imageOffsetBottom: PropTypes.number,
}

HeroBreakoutModule.defaultProps = {
  imageOffsetBottom: 3,
}

export default withTheme(HeroBreakoutModule)
